import React from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { HdResolvedComponent } from '../../../routing/components/resolved-component/HdResolvedComponent';
import { HdButton } from '../../../components';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { HdAuthRequestType } from '../../interfaces/auth';
import { HdAuth } from '../auth-layout/AuthLayout';
import { FeaturedCustomers } from '../testimonial-section/TestimonialSection';
import { useFeaturedCustomers } from '../../hooks/useFeaturedCustomer';
import { useVerifyEmail } from '../../hooks/useVerifyEmail';

export interface VerifyEmailProps {
  featuredCustomers: FeaturedCustomers;
  email: string;
}

export function VerifyEmail() {
  const { getFeaturedCustomers } = useFeaturedCustomers();
  const { verifyEmail } = useVerifyEmail();

  return (
    <HdResolvedComponent
      Component={VerifyEmailInner}
      resolve={{
        featuredCustomers: getFeaturedCustomers,
        email: verifyEmail
      }}
    />
  );
}

function VerifyEmailInner({ email, featuredCustomers }: VerifyEmailProps) {
  const history = useHistory();

  const dataIdGenerator = getDataIdGenerator('verify-email');

  return (
    <HdAuth
      selectedAuthType={HdAuthRequestType.EMAIL_VERIFIED}
      featuredCustomers={featuredCustomers}
    >
      <HdButton
        dataId={dataIdGenerator('submit')}
        size='lg'
        className='w-100'
        onClick={() => history.push(`/login?email=${email}`)}
      >
        Log In
      </HdButton>
    </HdAuth>
  );
}
